<template>
    <div class="flex flex-col mb-3 md:mb-0">
        <label class="rounded overflow-hidden shadow">
            <div class="p-2.5 shine min-h-[3rem]" />
            <div class="px-2.5 py-4 flex  text-base xs:text-lg">
                <div class="w-3/4 pl-6 pr-2.5">
                    <p class="w-1/3 shine mb-3.5 min-h-[1rem ] rounded-lg" />
                    <p class="w-2/3 shine min-h-[1rem] rounded-lg" />
                </div>
                <div class="w-1/4">
                    <p class="w-1/3 shine mb-3.5 min-h-[1rem ] rounded-lg" />
                    <p class="w-2/3 shine min-h-[1rem] rounded-lg" />
                </div>
            </div>
        </label>
    </div>
</template>

<script>
export default {

};
</script>
